<h2 mat-dialog-title>{{ selectTextureMap ? "Choose texture" : "Import texture set" }}</h2>
<mat-dialog-content>
    <div class="cm-source">From material {{ data.sourceMaterial.legacyId }} - {{ data.sourceMaterial.name ?? "Untitled" }}</div>
    @switch ($step()) {
        @case ("loading") {
            <div class="cm-message">Loading texture sets...</div>
        }
        @case ("empty") {
            <div class="cm-message">This material has no texture sets that can be {{ selectTextureMap ? "used" : "imported" }}.</div>
        }
        @case ("textureSet") {
            <div class="cm-prompt">Select a texture set</div>
            <div class="cm-options">
                @for (textureSet of $textureSets(); track textureSet.id) {
                    <cm-card [defaultThumbnail]="false" (selectItem)="chooseTextureSet(textureSet)">
                        <ng-container cm-thumbnail>
                            <cm-data-object-thumbnail [dataObjectId]="getThumbnailId(textureSet.textureSetRevisions[0])"></cm-data-object-thumbnail>
                        </ng-container>
                        <ng-container cm-title>{{ textureSet.legacyId }} - {{ textureSet.name ?? "Untitled" }}</ng-container>
                        <ng-container cm-subtitle>{{ textureSet.textureSetRevisions.length }} revision(s)</ng-container>
                    </cm-card>
                }
            </div>
        }
        @case ("revision") {
            <div class="cm-prompt">Select a revision of {{ $textureSet()?.legacyId }} - {{ $textureSet()?.name ?? "Untitled" }}</div>
            <div class="cm-options">
                @for (option of $revisionOptions(); track option.revision.id) {
                    <cm-card [defaultThumbnail]="false" [disabled]="!!option.blockedReason" (selectItem)="chooseRevision(option)">
                        <ng-container cm-thumbnail>
                            <cm-data-object-thumbnail [dataObjectId]="option.thumbnailId"></cm-data-object-thumbnail>
                        </ng-container>
                        <ng-container cm-title>{{ option.title }}</ng-container>
                        <ng-container cm-subtitle>
                            @if (option.blockedReason; as blockedReason) {
                                {{ blockedReason }}
                            } @else {
                                {{ option.revision.width }} × {{ option.revision.height }} cm, {{ option.revision.createdBy?.firstName }}
                                {{ option.revision.createdAt | cmTimeAgo }}
                            }
                        </ng-container>
                    </cm-card>
                }
            </div>
        }
        @case ("confirm") {
            @if ($revisionOption(); as option) {
                <div class="cm-confirm">
                    <div class="cm-confirm-thumbnail">
                        <cm-data-object-thumbnail [dataObjectId]="$confirmThumbnailId()"></cm-data-object-thumbnail>
                    </div>
                    <div class="cm-confirm-details">
                        <div class="cm-confirm-title">{{ $textureSet()?.legacyId }} - {{ $textureSet()?.name ?? "Untitled" }}</div>
                        <div>Revision {{ option.title }}</div>
                        <div>{{ option.revision.width }} × {{ option.revision.height }} cm</div>
                        @if (!selectTextureMap) {
                            <div class="cm-prompt">
                                This creates a new texture set on the current material with a copy of this revision, including its edits.
                            </div>
                        }
                    </div>
                </div>
                @if (selectTextureMap) {
                    <div class="cm-prompt cm-texture-type-prompt">Select a texture type</div>
                    <div class="cm-options">
                        @for (textureMapOption of $textureMapOptions(); track textureMapOption.textureType) {
                            <cm-card
                                [class.cm-selected]="textureMapOption.textureType === $textureMapOption()?.textureType"
                                [defaultThumbnail]="false"
                                (selectItem)="chooseTextureType(textureMapOption.textureType)"
                            >
                                <ng-container cm-thumbnail>
                                    <cm-data-object-thumbnail [dataObjectId]="textureMapOption.dataObjectId"></cm-data-object-thumbnail>
                                </ng-container>
                                <ng-container cm-title>{{ textureMapOption.label }}</ng-container>
                            </cm-card>
                        }
                    </div>
                }
            }
        }
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [disabled]="$importing() || $step() === 'loading'" (click)="back()">Back</button>
    <button mat-button [disabled]="$importing()" (click)="cancel()">Cancel</button>
    @if ($step() === "confirm") {
        @if (selectTextureMap) {
            <button mat-button [disabled]="!$textureMapOption()" (click)="confirmSelection()">Select</button>
        } @else {
            <button mat-button [disabled]="$importing()" (click)="confirmImport()">Import</button>
        }
    }
</mat-dialog-actions>
